module.exports = __webpack_public_path__ + "static/media/bw-c2.64b7443a.svg";